// ColacionBoxplotChart.jsx
import React from 'react';
import { BoxplotChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

const ColacionBoxplotChart = ({
  data = [],
  title = 'Distribución de duración de colación',
  height = '400px',
}) => {

  const chartData = data.map(d => ({
    group: d.group,   // Ej: "2025-11-20 Día"
    key: d.key,       // "Duración"
    value: d.value,   // horas
  }));

  const options = {
    title,
    height,

    // ⬅⬅⬅ Modo oscuro con textos blancos
    theme: 'g100',

    axes: {
      bottom: {
        mapsTo: 'group',
        title: 'Turno (día/noche)',
        scaleType: 'labels',
      },
      left: {
        mapsTo: 'value',
        title: 'Duración colación (horas)',
        scaleType: 'linear',
      },
    },

    legend: {
      enabled: false,
    },

    color: {
      scale: {
        Duración: '#78A9FF', // azul claro luminoso
      },
    },
  };

  return <BoxplotChart data={chartData} options={options} />;
};

export default ColacionBoxplotChart;